const defaultState = {
    isLoginSuccess: false,
    isLoginPending: false,
    user: null,
    loginError: null
};

export default function loginReducer(state = defaultState, action = {}) {
    switch (action.type) {
        case "SET_LOGIN_PENDING":
            return {
                ...state,
                isLoginPending: true,
                loginError: null
            };

        case "SET_LOGIN_SUCCESS":
            return {
                ...state,
                isLoginSuccess: true,
                isLoginPending: false,
                user: action.user,
                loginError: null
            };

        case "SET_LOGIN_ERROR":
            return {
                ...state,
                isLoginPending: false,
                loginError: action.error,
                isLoginSuccess: false
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/login-reducer.js